import { useEffect, useRef, useState } from 'react';
import { PageTitle } from '../../components/title/PageTitle';
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { getKeywordEvents } from '../../api/home';
import '../../css/Exhibition.css';
import { KeywordEventType } from '../../@types/home';
import { useCommonContext } from '../../components/provider/CommonProvider';

export default function EventList() {
  const [item, setItem] = useState<KeywordEventType[]>([]);
  const [tab, setTab] = useState<string>('진행');
  const navigate = useNavigate();
  const { setIsLottie } = useCommonContext();
  const obsRef = useRef(null); //observer Element

  useEffect(() => {
    const fetchEvents = (status: string) => {
      getKeywordEvents('이벤트', status).then((res) => {
        let filteredData = res.data;

        // '진행' 탭일 때 필터링 처리
        if (tab === '진행') {
          filteredData = res.data.filter((el: any) => Number(el.eventNo) !== 43284);
        }

        setItem(filteredData);
      });
    };

    if (tab === '진행') {
      fetchEvents('ING');
    } else if (tab === '종료') {
      fetchEvents('END');
    }
  }, [tab]);
  return (
    <>
      {isMobile ? (
        <div className="main_wrap">
          <div className="contents_wrap">
            <PageTitle className="center">이벤트</PageTitle>
          </div>
          <div className="exhibition_list">
            <div className="tab_wrap">
              <div className="tab_container">
                <div
                  className={tab === '진행' ? 'tab on' : 'tab'}
                  onClick={() => {
                    setTab('진행');

                    setIsLottie(true);
                  }}
                >
                  진행 중 이벤트
                </div>
                <div
                  className={tab === '종료' ? 'tab on' : 'tab'}
                  onClick={() => {
                    setTab('종료');

                    setIsLottie(true);
                  }}
                >
                  종료 이벤트
                </div>
              </div>
            </div>
            <div className="contents_wrap">
              <div className="exhibition_list_cont">
                {item?.map((el: any, idx: number) => {
                  return (
                    <div
                      className="item"
                      onClick={() => {
                        if (tab === '진행') {
                          navigate(`/eventdetail/${el.eventNo}`);
                        }
                      }}
                      key={idx}
                    >
                      <img
                        src="../../images/exhibition_bg.png"
                        style={{
                          backgroundImage: `url(${isMobile ? el.mobileimageUrl : el.pcImageUrl})`,
                        }}
                        alt=""
                      />
                      <div>
                        <p>{el.label}</p>
                        <span>{`${el.startYmdt
                          .split(' ', 1)
                          .join('')
                          .replaceAll('-', '. ')
                          .replaceAll('. 0', '. ')} - ${el.endYmdt
                          .split(' ', 1)
                          .join('')
                          .replaceAll('-', '. ')
                          .replaceAll('. 0', '. ')}`}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div ref={obsRef} style={{ height: '10px' }}></div>
          </div>
        </div>
      ) : (
        // pc
        <div className="main_wrap">
          <div className="contents_wrap">
            <PageTitle className="center">이벤트</PageTitle>
          </div>
          <div className="exhibition_list">
            <div className="tab_wrap">
              <div className="tab_container">
                <div className="tab on">진행 중 이벤트</div>
                <div className="tab">종료 이벤트</div>
              </div>
            </div>
            <div className="contents_wrap">
              <div className="exhibition_list_cont">
                {item.map((el: any, index: number) => {
                  return (
                    <div
                      className="item"
                      onClick={() => {
                        navigate(`/exhibitiondetail/${el.eventNo}`);
                      }}
                      key={`${index}+${el.eventNo}`}
                    >
                      <img
                        src="../../images/exhibition_bg.png"
                        style={{
                          backgroundImage: `url(${isMobile ? el.mobileimageUrl : el.pcImageUrl})`,
                        }}
                        alt=""
                      />
                      <div>
                        <p>{el.label}</p>
                        <span>{`${el.startYmdt

                          .split(' ', 1)
                          .join('')
                          .replaceAll('-', '. ')
                          .replaceAll('. 0', '. ')} - ${el.endYmdt
                          .split(' ', 1)
                          .join('')
                          .replaceAll('-', '. ')
                          .replaceAll('. 0', '. ')}`}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
